export type Cookies = Map<string, string>;

export function getCookies(doc: Document): Cookies | null {
    if (!doc?.cookie) {
        return null;
    }

    const cookies = doc.cookie?.split(';');

    if (!cookies.length) {
        return null;
    }

    const entries = cookies.map((c) => {
        const cookie = c.trim().split('=');

        return [cookie[0].trim(), cookie[1].trim()] as [string, string];
    });

    return new Map<string, string>(entries);
}
